import React, {useEffect} from 'react';
import {connect} from 'react-redux';

const Title = (props) => {
  return (
    <div className='imei-device-repair-title'>
      <div className='text'>{props.text}</div>
      {props.subtext && <div className='subtext'>{props.subtext}</div>}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {deviceRepairData: state.iMEIDeviceRepair};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Title);
